export default __webpack_public_path__ + "static/media/MasaiOneCourseImage2.3e6d52bb.svg";